import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAppUserCustomFields } from '../api/appUserApi';

export default function useCustomColumns() {
  const { data: fields = [] } = useQuery({
    queryKey: ['useAppUserCustomFields'],
    queryFn: getAppUserCustomFields,
  });
  const showInUserList = fields.filter((f) => f.showInUserList);
  const customColumns = showInUserList.map((f) => {
    return {
      label: f.title,
      valueField: `appUserCustomFieldInstances.${f.field}.value`,
      sortable: true,
      renderer: (item) => {
        const value = item.appUserCustomFieldInstances.find(
          (i) => i.appUserCustomFieldId === f.id
        )?.value;
        return <>{value}</>;
      },
    };
  });

  return {
    customColumns,
  };
}
